import { useState, useEffect } from 'react'
import { EffectComposer, Bloom, N8AO, ToneMapping, LUT } from '@react-three/postprocessing'
import { LUTCubeLoader } from 'three/examples/jsm/loaders/LUTCubeLoader'

export function Effects() {
  const [texture, setTexture] = useState(null)

  useEffect(() => {
    fetch('/F-6800-STD.cube.txt')
      .then((res) => res.text())
      .then((text) => {
        const loader = new LUTCubeLoader()
        const result = loader.parse(text)
        setTexture(result.texture3D)
      })
  }, [])

  return (
    <EffectComposer>
      <Bloom luminanceThreshold={0.1} mipmapBlur luminanceSmoothing={10} intensity={0.9} />
      {texture && <LUT lut={texture} />}
    </EffectComposer>
  )
}
export default Effects
